import config from './config';
import { createApiClient, type AuthInterceptor } from '@wavvest/shared-services';
import { navigateToLogin, getItemWithExpiry } from '@wavvest/shared-utils';
import { clearAuthStorage } from '@/util/util';
import { notifySubscriptionRequired } from '@/features/subscription-entitlement/navigation';
import { installMembershipRecovery } from '@/features/session-recovery/membership-recovery';

// Auth interceptor — advisor portal reads a localStorage token (with expiry)
// and on auth failure clears storage and navigates to /login.
const authInterceptor: AuthInterceptor = {
  onRequest: (reqConfig) => {
    const accessToken = getItemWithExpiry('access_token');
    if (accessToken) {
      reqConfig.headers.Authorization = accessToken;
    }
    return reqConfig;
  },
  onUnauthorized: () => {
    clearAuthStorage();
    navigateToLogin();
  },
};

const ServiceInstance = createApiClient({
  baseURL: config.baseURL,
  timeout: config.timeout,
  headers: config.headers,
  authInterceptor,
  retryOnTimeout: true,
});

installMembershipRecovery(ServiceInstance);

ServiceInstance.interceptors.response.use(undefined, (error: unknown) => {
  notifySubscriptionRequired(error);
  return Promise.reject(error);
});

export const FeatureFlagsInstance = createApiClient({
  baseURL: config.featureFlagsBaseURL,
  timeout: config.timeout,
  headers: config.headers,
  authInterceptor,
  retryOnTimeout: true,
});

export const RiaAdminInstance = createApiClient({
  baseURL: config.riaAdminBaseURL,
  timeout: config.timeout,
  headers: config.headers,
  authInterceptor,
  // RiaAdminInstance historically retried timeouts against ServiceInstance,
  // not against itself. Preserve that exact behavior.
  retryOnTimeout: ServiceInstance,
});

export default ServiceInstance;
